import { Button, Collapse, FormControlLabel, MenuItem, Radio, Select, Switch } from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { useMemo, useEffect, useReducer, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FilterFuntion, useSchemeSearch } from '../../../../hooks/useSchemeData';
import en from '../../../../lang/en-us';
import { CheckBoxField } from '../../../../lib/CheckBoxField';
import SearchInput from '../../../../lib/SearchInput';
import { getMasterData } from '../../../../redux-store/actions/newPurchase';
import { RootStateType } from '../../../../redux-store/reducers';
import { SwipeableDrawer } from '@material-ui/core';
import { _debounce } from '../../../../utils/utilityFunctions';
import { AutoSizer, InfiniteLoader, List } from 'react-virtualized';
import {
    Filter,
    Id,
    MFFilterBoxProps,
    MinimunInvestMentTypes,
    ReturnPeriods,
    ReturnsTimeLines,
} from '../ExploreMFs/types';
import AsyncLoader from '../../../../lib/AsyncLoader';
import { SchemeListCardSkelton } from '../../../../skeltons/NewPurchase';
import NoFoliosFound from '../../makeNct/NoFoliosFound';
import { CommercialRootPath } from '../routeConfig';
import { SwitchPaths, SwitchSelectTo } from './types';
import { useHistory } from 'react-router';
import { PlanTypes, SCHEMES_RESPONSE } from '../../../../redux-store/types/portfolio';
import { STPPaths } from '../STP/types';

const { dbCommercial } = en;

enum SelectSchemesFrom {
    Existing,
    New,
}
enum FilterKeys {
    Categories = 'categories',
    Amcs = 'amcs',
    PlanMode = 'planMode',
    MinimunInvestment = 'minimumInvestment',
}
enum MOBILE_FILTERS {
    F = 'fund house',
    C = 'category',
    S = 'fund size',
    R = 'risk',
    RE = 'returns',
    P = 'plan',
    MIN_INVEST = 'minimunInvestment',
    SELECT_SCHEMES = 'scheme',
}

interface Props {
    existingFunds: SCHEMES_RESPONSE[];
    fromScheme: SCHEMES_RESPONSE;
    stpFlag?: boolean;
}

export function RadioFields({ label, onChange = (e: any) => { }, value = false }: any) {
    return (
        <div className="radio-div">
            <FormControlLabel
                control={<Radio onChange={onChange} checked={value} />}
                label={label || ''}
            />
        </div>
    );
}
export const getSubcategory = (subcategoryName: string = '') =>
    subcategoryName.split(': ')[1] || '';

const initFilters: SwitchSelectTo<Filter> = {
    categories: [],
    amcs: [],
    planMode: [],
    minimumInvestment: [],
};

function filterReducer(
    state: SwitchSelectTo<Filter>,
    action: {
        type: FilterKeys;
        payload: Filter[];
        actionType?: string;
        initState?: SwitchSelectTo<Filter>;
    },
): SwitchSelectTo<Filter> {
    const { payload, type, actionType, initState = initFilters } = action;
    switch (actionType) {
        case 'CLEAR':
        case 'CANCEL':
            const { planMode } = state;
            const { planMode: initPlanMode, ...rest } = initState;
            return { planMode, ...rest };

        default:
            return { ...state, [type]: payload };
    }
}

const SchemeList = (props: Props) => {
    const [open, setOpen] = useState<boolean>(true);
    const [openDrawer, setDrawer] = useState<boolean>(false);
    const [mobileFilter, setMobileFilter] = useState<string>(MOBILE_FILTERS.C);
    const [schemeSearch, setSchemeSearch] = useState<string | null>(null);
    const [selectSchemeCollapse, setSelectSchemeCollapse] = useState<boolean>(true);
    const [selectCategoryCollapse, setSelectCategoryCollapse] = useState<boolean>(true);
    // const [amcNames, setAmcNames] = useState<any[]>([]);
    const [filters, setFilters] = useState<FilterFuntion[]>([]);
    const [data, setData] = useState<any[]>([]);
    const [selectSchemes, setSelectSchemes] = useState<SelectSchemesFrom>(SelectSchemesFrom.New);
    const history = useHistory();
    const [returnTimeLine, SetReturnTimeLine] = useState<ReturnsTimeLines>(
        ReturnsTimeLines.Three_Years,
    );
    const initState = {
        ...initFilters,
        amcs: [{ name: props.fromScheme?.amcName, value: props.fromScheme?.amc }],
    };

    const [filterState, dispatchFilter] = useReducer(filterReducer, initState);

    const { exploreSchemeData, masterData } = useSelector(({ newPurchase }: RootStateType) => ({
        ...newPurchase,
    }));
    const prevFilters = useRef<SwitchSelectTo<Filter> | null>(null);

    const { exploreData, nextPage } = useSchemeSearch({
        filters,
    });

    const handleClick = () => {
        setOpen(!open);
    };

    const dispatch = useDispatch();

    useEffect(() => {
        async function getData() {
            try {
                await dispatch(getMasterData());
                // const data = res.body || {};
                // setAmcNames(data?.amcDetails);
            } catch (err: any) {
                alert(err.message);
            }
        }
        getData();
    }, []);

    useEffect(() => {
        setData(exploreData);
    }, [exploreData]);

    useEffect(() => {
        // [FIX-ME] Dynamically provide specfied search data.
        const { categories, amcs, planMode, minimumInvestment } = filterState;
        const amcFilterFunc: FilterFuntion = ({ fundAmcCode }) => {
            return !amcs.length || !!amcs.find((_amc) => _amc.value === `${fundAmcCode}`);
        };
        const categoriesFunc: FilterFuntion = ({ schemeCategoryID, schemeSubCategoryID }) => {
            return (
                !categories.length ||
                !!categories.find(
                    (category) =>
                        category.value === schemeCategoryID &&
                        (!category.sub?.length ||
                            !!category.sub?.find((sub) => sub.value === schemeSubCategoryID)),
                )
            );
        };
        const schemsFilter: FilterFuntion = ({ isinCode }) =>
            selectSchemes === SelectSchemesFrom.Existing
                ? props.existingFunds.some((fund) => fund.isin === isinCode)
                : props.fromScheme.isin !== isinCode;
        const searchBySchemeName: FilterFuntion = ({ schemeName }) => {
            const value = schemeSearch?.toLowerCase();
            const targetValue = schemeName?.toLowerCase();
            return !!schemeSearch ? targetValue?.includes(value) : true;
        };
        const planModeFunc: FilterFuntion = ({ plan }) => {
            return (
                !planMode.length ||
                !!planMode.find((_plan) =>
                    _plan.value === PlanTypes.Direct
                        ? [PlanTypes.D, PlanTypes.Direct].includes(plan.toUpperCase())
                        : [PlanTypes.R, PlanTypes.Reggular].includes(plan.toUpperCase()),
                )
            );
        };
        const minimumInvestmentFunc: FilterFuntion = ({ minAmountLumpsum, minAmountSIP }) => {
            const minLumpsum = isNaN(minAmountLumpsum) ? 0 : Number(minAmountLumpsum);
            const minSIP = isNaN(minAmountSIP) ? 0 : Number(minAmountSIP);
            return (
                !minimumInvestment.length ||
                !!minimumInvestment.some((investmentAmount) => {
                    if (investmentAmount.value === MinimunInvestMentTypes.LESS_THAN_FIVE_HUNDRED) {
                        return minLumpsum <= 500;
                    }
                    if (
                        investmentAmount.value ===
                        MinimunInvestMentTypes.FIVE_HUNDRED_TO_TWO_THOUSAND
                    ) {
                        return minLumpsum >= 501 && minLumpsum <= 2000;
                    }
                    if (
                        investmentAmount.value === MinimunInvestMentTypes.GREATER_THAN_TWO_THOUSAND
                    ) {
                        return minLumpsum > 2000;
                    }
                })
            );
        };
        setFilters([
            categoriesFunc,
            amcFilterFunc,
            schemsFilter,
            searchBySchemeName,
            planModeFunc,
            minimumInvestmentFunc,
        ]);
    }, [filterState, selectSchemes, schemeSearch]);

    const handleFilterChange = (filter: Filter, type: FilterKeys) => (): void => {
        const payload = filterItems(filterState[`${type}`], filter);
        dispatchFilter({ type, payload });
    };

    const handleSubFilters = (type: FilterKeys, index: number, data: Filter) => (): void => {
        let items = filterState[`${type}`];
        const _item = items[index];
        const sub = filterItems(_item.sub || [], data);
        items[index] = { ..._item, sub };
        dispatchFilter({ type, payload: [...items] });
    };

    const filterItems = (list: any[] = [], target: Filter): Filter[] => {
        const index = list.findIndex((item) => item.value === target.value);
        return index === -1
            ? [...list, target]
            : list.filter((item) => target.value !== item.value);
    };

    function isRowLoaded({ index }: any) {
        return !!data[index];
    }

    function loadMoreRows({ startIndex }: any) {
        const { value = [] }: any = nextPage?.next(startIndex);
        return Promise.resolve(setData((prev) => [...prev, ...value]));
    }

    function rowRenderer({ key, index, style }: any) {
        const scheme: any = data[index] || {};
        const returns = parseFloat(Number(scheme.threeYearReturns).toFixed(2)) || NaN;
        return (
            <div key={key} style={{ ...style, top: style.top + 20, width: '100%' }}>
                <MutualFundBox
                    key={scheme.isinCode}
                    fund={scheme}
                    history={history}
                    profit={returns}
                    image={scheme.fundLogo}
                    isinCode={scheme.isinCode}
                    year={returnTimeLine}
                />
            </div>
        );
    }

    const MutualFundBox = ({ image, fund, year, isinCode }: MFFilterBoxProps) => {
        const { schemeName, schemeCategory, returns, schemeSubCategory } = fund;
        const categories = [schemeCategory, getSubcategory(schemeSubCategory)];
        const profit = parseFloat(Number(returns[year]).toFixed(2)) || NaN;
        return (
            <a style={{ height: '90%', alignItems: 'center' }} className="mf-filters-info">
                <div className="logo">
                    <img
                        style={{ width: '35px', height: '35px' }}
                        src={`/images/fav-logos/${image}`}
                        alt="icon"
                    />
                </div>
                <div className="mf-filters-title">
                    <h4>{schemeName}</h4>
                    <p>
                        {categories.map((category: string) => (
                            <span> {category}</span>
                        ))}
                    </p>
                </div>
                <div className="mf-filters-info-right">
                    <div className="mf-filters-percent">
                        <h6 style={{ color: profit >= 0 ? '#1bc387' : 'black' }}>
                            {profit >= 0 ? '+' : ''}
                            {!!profit ? `${profit}%` : 'NA'}
                        </h6>
                        <p>
                            {ReturnPeriods.find((time) => time.value === year)?.shortLabel} Returns
                        </p>
                    </div>
                    {/* <img className="arrow" src="/images/right-arrow.svg" alt="icon" /> */}
                </div>
                <div
                    onClick={() => {
                        let path = `${CommercialRootPath}${SwitchPaths.SwitchChangeRequest}`;
                        if (props.stpFlag) {
                            path = `${CommercialRootPath}${STPPaths.STPChangeRequest}`;
                        }
                        const stateObject = props.stpFlag
                            ? {
                                stpFromScheme: props.fromScheme,
                                stpToScheme: { ...fund, isin: isinCode },
                            }
                            : {
                                switchFromScheme: props.fromScheme,
                                switchToScheme: { ...fund, isin: isinCode },
                            };
                        history.replace(`${path}?amc=${fund?.fundAmcCode}`, stateObject);
                    }}
                    className="switch-filters-select"
                >
                    <a className="switch-select-scheme-btn">Select Scheme</a>
                </div>
            </a>
        );
    };

    const deleteFilter = (type: FilterKeys, parentId: Id, subId?: Id) => (): void => {
        let items = filterState[`${type}`];
        const parentIndex = items.findIndex((category) => category.value === parentId);
        if (subId) {
            const _item = items[parentIndex];
            const sub = _item.sub?.filter((sub) => sub.value !== subId);
            items[parentIndex] = { ..._item, sub };
            dispatchFilter({ type, payload: [...items] });
            return;
        }
        items.splice(parentIndex, 1);
        dispatchFilter({ type, payload: items });
    };

    const onMobileFilterOpen = () => {
        setDrawer(true);
        // hold previous filters to handle cancel
        prevFilters.current = filterState;
    };

    const onCancelFilter = () => {
        dispatchFilter({
            type: FilterKeys.Amcs,
            payload: [],
            initState: !!prevFilters.current ? prevFilters.current : initFilters,
            actionType: 'CANCEL',
        });
        setDrawer((prev) => !prev);
    };

    const showFilterCount = (): string => {
        const count = filterState.categories.length;
        return !!count ? `-${count}` : '';
    };

    const FilterChip = ({
        filter,
        type,
        subId,
    }: {
        filter: Filter;
        type: FilterKeys;
        subId?: Id;
    }) => {
        return (
            <a>
                {filter.name}{' '}
                <img
                    onClick={deleteFilter(type, filter.value, subId)}
                    src="/images/close-black.svg"
                    alt="icon"
                />
            </a>
        );
    };

    const renderSelectedFilters = () => {
        return (Object.keys(filterState) as Array<FilterKeys>)
        .filter((type) => type !== FilterKeys.PlanMode && type !== FilterKeys.Amcs)
        .map(
            (type) =>
                filterState[type].map((item) =>
                    !!item.sub?.length ? (
                        item.sub.map((_sub) => (
                            <FilterChip
                                key={`${type}-${_sub.value}`}
                                filter={{ ...item, name: `${item.name} - ${_sub.name}` }}
                                type={type}
                                subId={_sub.value}
                            />
                        ))
                    ) : (
                        <FilterChip key={`${type}-${item.value}`} filter={item} type={type} />
                    ),
                ),
        );
    };

    const [planMode, setPlanMode] = useState<PlanTypes>(PlanTypes.Direct);

    const PlanModeObject: { [key: string]: any } = {
        [PlanTypes.Direct]: { label: 'Direct', value: PlanTypes.Direct },
        [PlanTypes.Reggular]: { label: 'Regular', value: PlanTypes.Reggular },
    };

    useEffect(() => {
        deleteFilter(
            FilterKeys.PlanMode,
            planMode === PlanTypes.Reggular ? PlanTypes.Direct : PlanTypes.Reggular,
        )();
        handleFilterChange(
            { value: PlanModeObject[planMode].value, name: PlanModeObject[planMode].label },
            FilterKeys.PlanMode,
        )();
    }, [planMode]);

    const PlanModeSwitch = (
        <div className="toggle-tabs">
            <a className={planMode === PlanTypes.Direct ? 'active' : ''}> Direct </a>
            <div className="toggle">
                <Switch
                    checked={planMode === PlanTypes.Direct ? false : true}
                    value={planMode}
                    onChange={(e) => {
                        setPlanMode(e.target.checked ? PlanTypes.Reggular : PlanTypes.Direct);
                    }}
                    name="signInToggle"
                    inputProps={{ 'aria-label': 'toggleSwitch' }}
                />
            </div>
            <a className={planMode === PlanTypes.Reggular ? '' : 'active'}> Regular </a>
        </div>
    );


    const CategoryFilters = () => {
        return masterData.categories.map(({ categoryId, categoryName, subcategory }) => (
            <>
                <CheckBoxField
                    value={
                        !!filterState.categories.find((category) => category.value === categoryId)
                    }
                    onChange={handleFilterChange(
                        { value: categoryId, name: categoryName },
                        FilterKeys.Categories,
                    )}
                    key={categoryId}
                    label={categoryName}
                />
                {!!filterState.categories.find((category) => category.value === categoryId) && (
                    <div className="sub-category">
                        {subcategory.map(({ subcategoryId, subcategoryName }) => {
                            const index = filterState.categories.findIndex(
                                (category) => category.value === categoryId,
                            );
                            const name = getSubcategory(subcategoryName);
                            return (
                                <CheckBoxField
                                    value={
                                        !!filterState.categories[index]?.sub?.find(
                                            (subCategory) => subCategory.value === subcategoryId,
                                        )
                                    }
                                    onChange={handleSubFilters(FilterKeys.Categories, index, {
                                        name,
                                        value: subcategoryId,
                                    })}
                                    key={categoryId + `${subcategoryName}`}
                                    label={name}
                                />
                            );
                        })}
                    </div>
                )}
            </>
        )) as any;
    };

    const PlanModeFilters = (
        <div className="fund-house-list">
            {[
                { label: 'Direct', value: PlanTypes.Direct },
                { label: 'Regular', value: PlanTypes.Reggular },
            ].map((plan) => (
                <CheckBoxField
                    value={!!filterState.planMode.find((_plan) => plan.value === _plan.value)}
                    onChange={handleFilterChange(
                        { value: plan.value, name: plan.label },
                        FilterKeys.PlanMode,
                    )}
                    label={plan.label}
                />
            ))}
        </div>
    );

    const MinimunInvestmentTypeFilter = (
        <div className="fund-house-list">
            {[
                { label: '<=₹500', value: MinimunInvestMentTypes.LESS_THAN_FIVE_HUNDRED },
                { label: '₹501-₹2000', value: MinimunInvestMentTypes.FIVE_HUNDRED_TO_TWO_THOUSAND },
                { label: '>₹2000', value: MinimunInvestMentTypes.GREATER_THAN_TWO_THOUSAND },
            ].map(({ label, value: minAmount }) => (
                <CheckBoxField
                    value={
                        !!filterState.minimumInvestment.find((invest) => invest.value === minAmount)
                    }
                    onChange={handleFilterChange(
                        { value: minAmount, name: label },
                        FilterKeys.MinimunInvestment,
                    )}
                    label={label}
                />
            ))}
        </div>
    );

    const SchemeSelection = () => {
        return (
            <Collapse in={true} unmountOnExit>
                <div>
                    <RadioFields
                        value={selectSchemes === SelectSchemesFrom.Existing}
                        label={'Existing'}
                        onChange={() => setSelectSchemes(SelectSchemesFrom.Existing)}
                    />
                    <RadioFields
                        value={selectSchemes === SelectSchemesFrom.New}
                        label={'New Scheme'}
                        onChange={() => setSelectSchemes(SelectSchemesFrom.New)}
                    />
                </div>
            </Collapse>
        );
    };

    const ReturnFilters = (
        <Select
            style={{
                padding: '1px',
                fontSize: '12px',
                width: 110,
            }}
            variant="outlined"
            onChange={({ target: { value } }) => SetReturnTimeLine(value as ReturnsTimeLines)}
            value={returnTimeLine}
        >
            {ReturnPeriods.map((time) => (
                <MenuItem value={time.value}>{time.label}</MenuItem>
            ))}
        </Select>
    );

    const renderMobileFilters = useMemo(() => {
        switch (mobileFilter) {
            case MOBILE_FILTERS.C:
                return <CategoryFilters />;
            case MOBILE_FILTERS.SELECT_SCHEMES:
                return <SchemeSelection />;
            case MOBILE_FILTERS.MIN_INVEST:
                return MinimunInvestmentTypeFilter;
            case MOBILE_FILTERS.RE:
                return ReturnFilters;
            default:
                return null;
        }
    }, [mobileFilter, filterState, selectSchemes, returnTimeLine]);

    return (
        <div className="curved-bg faq-curved commercial-trans new-purchase">
            <div
                style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}
                className="explore-mf-heading"
            >
                <div className="explore-mf-search">
                    <SearchInput
                        id="search-mfs"
                        placeholder={dbCommercial.exploreMfs.searchmf}
                        darkmode={true}
                        options={exploreData}
                        onChange={(e: any) => setSchemeSearch(e.target.value)}
                    />
                </div>
            </div>
            <div className="plan_mode_switch">
                <div className="mobile_mode">
                    {PlanModeSwitch}
                </div>
                <div className="explore-mf-filter-mobile mobile_mode">
                    <a onClick={onMobileFilterOpen}>
                        <img src="/images/filters.svg" alt="icon" />
                        {dbCommercial.exploreMfs.filter}
                        {showFilterCount()}
                    </a>
                </div>
            </div>
            <div className="curved-bg-content explore-mf-filters">
                <div className="faq-content-outer">
                    <div className="faq-content-left desktop_mode">
                        {PlanModeSwitch}
                        <div className="filters-top">
                            <h5>
                                <img src="/images/filters.svg" alt="icon" />
                                {dbCommercial.exploreMfs.filters}
                            </h5>
                        </div>
                        <div className="fund-plan">
                            <h4>{dbCommercial.exploreMfs.planFilterTitle}</h4>
                            {PlanModeFilters}
                        </div>
                        <div className="fund-returns">
                            <h4>{dbCommercial.exploreMfs.returnDuration}</h4>
                            {ReturnFilters}
                        </div>
                        {/* <div className="fund-min-invest">
                            <h4>{dbCommercial.exploreMfs.minimumInvestmentFilterTitle}</h4>
                            {MinimunInvestmentTypeFilter}
                        </div> */}
                        <div>
                            <h4
                                onClick={() => {
                                    setSelectSchemeCollapse(!selectSchemeCollapse);
                                }}
                            >
                                {dbCommercial.exploreMfs.selectScheme}
                                {selectSchemeCollapse ? <ExpandLess /> : <ExpandMore />}
                            </h4>
                            <Collapse in={selectSchemeCollapse} unmountOnExit>
                                <SchemeSelection />
                            </Collapse>
                        </div>
                        <div className="category">
                            <h4
                                onClick={() => {
                                    setSelectCategoryCollapse(!selectCategoryCollapse);
                                }}
                            >
                                {dbCommercial.exploreMfs.category}
                                {selectCategoryCollapse ? <ExpandLess /> : <ExpandMore />}
                            </h4>
                            <Collapse in={selectCategoryCollapse} unmountOnExit>
                                <CategoryFilters />
                            </Collapse>
                        </div>
                    </div>
                    <div className="faq-content-right">
                        <div className="faq-content-right-content">
                            <div className="new-purchase-right">
                                <div className="mf-selected-filters desktop_mode">
                                    <h5>{dbCommercial.exploreMfs.selectedFilters}:</h5>
                                    <div className="selected-filters-tags">
                                        {renderSelectedFilters()}
                                    </div>
                                </div>
                                <div className="mf-filters-total">
                                    {(Object.keys(filterState) as Array<FilterKeys>).some(
                                        (key) => !!filterState[`${key}`].length,
                                    ) &&
                                        !data.length &&
                                        !!exploreSchemeData.length ? (
                                        <NoFoliosFound info={en.common.noRecordsFound} />
                                    ) : (
                                        <AsyncLoader
                                            skelton={
                                                <div className="list-cards">
                                                    <SchemeListCardSkelton />
                                                </div>
                                            }
                                            data={exploreSchemeData.length ? true : null}
                                        >
                                            <InfiniteLoader
                                                isRowLoaded={isRowLoaded}
                                                loadMoreRows={loadMoreRows}
                                                rowCount={exploreSchemeData.length}
                                            >
                                                {({ onRowsRendered, registerChild }) => (
                                                    <AutoSizer disableHeight>
                                                        {({ width }) => (
                                                            <List
                                                                height={window.innerHeight - 190}
                                                                onRowsRendered={onRowsRendered}
                                                                ref={registerChild}
                                                                rowCount={data.length}
                                                                rowHeight={160}
                                                                rowRenderer={rowRenderer}
                                                                width={width}
                                                            />
                                                        )}
                                                    </AutoSizer>
                                                )}
                                            </InfiniteLoader>
                                        </AsyncLoader>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <SwipeableDrawer
                anchor={'bottom'}
                open={openDrawer}
                onClose={() => setDrawer(false)}
                onOpen={() => setDrawer(true)}
                className="explore-mf-drawer"
            >
                <div className="filters-drawer-total">
                    <div className="filters-top">
                        <h5>
                            <img
                                src="/images/right-arrow-long-black.svg"
                                alt="icon"
                                onClick={() => setDrawer(false)}
                            />
                            {dbCommercial.exploreMfs.filters}
                        </h5>
                        <a
                            onClick={() => {
                                dispatchFilter({
                                    type: FilterKeys.Amcs,
                                    payload: [],
                                    initState: { ...initState },
                                    actionType: 'CLEAR',
                                });
                                setDrawer(false);
                            }}
                        >
                            {dbCommercial.exploreMfs.clearAll}
                        </a>
                    </div>
                    <div className="filters-drawer-content">
                        <div className="filters-drawer-content-left">
                            <a onClick={() => setMobileFilter(MOBILE_FILTERS.C)}>
                                {dbCommercial.exploreMfs.category}
                            </a>
                            <a onClick={() => setMobileFilter(MOBILE_FILTERS.SELECT_SCHEMES)}>
                                {dbCommercial.exploreMfs.selectScheme}
                            </a>
                            <a onClick={() => setMobileFilter(MOBILE_FILTERS.RE)}>
                                {dbCommercial.exploreMfs.returnDuration}
                            </a>
                            {/* <a onClick={() => setMobileFilter(MOBILE_FILTERS.MIN_INVEST)}>
                                {dbCommercial.exploreMfs.minimumInvestmentFilterTitle}
                            </a> */}
                        </div>
                        <div className="filters-drawer-content-right">{renderMobileFilters}</div>
                    </div>
                    <div className="filters-drawer-bottom">
                        <div className="btns">
                            <Button className="customBtn cancelBtn" onClick={onCancelFilter}>
                                Cancel
                            </Button>
                            <Button className="customBtn" onClick={() => setDrawer(false)}>
                                Apply
                            </Button>
                        </div>
                    </div>
                </div>
            </SwipeableDrawer>
        </div>
    );
};

export default SchemeList;
